<template>
	<div class="top-section">
		<div class="banner" :style="{ backgroundImage: `url(${cdnHost}${game.gameBackground})` }">
			<img class="desktop shadow" :src="`${staticHost}images/game-details/shadow_1920.png`" />
			<img class="mobile shadow" :src="`${staticHost}images/game-details/shadow_768.png`" />
		</div>
		<div class="content">
			<div class="poster" :style="{ backgroundImage: `url(${cdnHost}${game.gameCardImage})` }"></div>
			<div class="info">
				<div class="title">{{ game.name }}</div>
				<!-- eslint-disable-next-line vue/no-v-html -->
				<div class="description" v-html="getLocaleString(game.subhead)"></div>
				<div class="links links-top">
					<template v-for="link in linksList">
						<div v-if="game[`${link}Link`]" :key="link" class="link" @click="openLink(game[`${link}Link`], link)">
							<svgIcon icon-holder-class="link-icon" :icon-id="`icon-${getLinkName(link, true)}`" />
							<span>{{ $t(`main.links.${getLinkName(link)}`) }}</span>
						</div>
					</template>
				</div>
				<div class="links links-bottom">
					<template v-for="link in linksList2">
						<div v-if="game[`${link}Link`]" :key="link" class="link" @click="openLink(game[`${link}Link`], link)">
							<svgIcon icon-holder-class="link-icon" :icon-id="`icon-${getLinkName(link, true)}`" />
							<!-- <span>{{ $t(`main.links.${getLinkName(link)}`) }}</span> -->
						</div>
					</template>
				</div>
			</div>
			<div class="download">
				<a
					v-if="game.enableCustomDownloadButton"
					class="secondary-button custom"
					:href="getLocaleString(game.customDownloadButtonLink)"
					target="_blank"
					rel="external"
					@click="trackDownload('Custom Button')"
				>
					<span>{{ getLocaleString(game.customDownloadButtonText) }}</span>
				</a>
				<button v-if="!game.enableCustomDownloadButton && isWindows && game.pc" @click="download">
					<svgIcon icon-holder-class="download-icon" icon-id="icon-ext-windows" />
					<span>{{ $t('main.download') }}</span>
				</button>
				<a
					v-if="!game.enableCustomDownloadButton && isWindows && game.steam && !game.pc"
					class="steam"
					:href="game.steam"
					target="_blank"
					rel="external"
					@click="trackDownload('Steam')"
				>
					<svgIcon icon-holder-class="download-icon" icon-id="icon-steam" />
					<span>{{ $t('main.play-on-steam') }}</span>
				</a>
				<a
					v-if="!game.enableCustomDownloadButton && isIOS && game.ios"
					:href="game.ios"
					target="_blank"
					rel="external"
					class="ios"
					@click="trackDownload('App Store')"
				>
					<img :src="`${staticHost}images/thirdparty-icons/itunes/itunes-${language}.svg`" />
				</a>
				<a
					v-if="!game.enableCustomDownloadButton && isAndroid && game.android"
					:href="game.android"
					target="_blank"
					rel="external"
					class="android"
					@click="trackDownload('Google Play Store')"
				>
					<img :src="`${staticHost}images/thirdparty-icons/google-play/google-play-${language}.png`" />
				</a>
				<span
					v-if="
						((!isWindows || game.enableCustomDownloadButton) && (game.pc || game.steam)) ||
							game.xbox ||
							game.psn ||
							((!isIOS || game.enableCustomDownloadButton) && game.ios) ||
							((!isAndroid || game.enableCustomDownloadButton) && game.android)
					"
					class="also-available"
					:class="{
						spacing: game.enableCustomDownloadButton || isGameSupported,
					}"
					>{{ $t(`main.${!isGameSupported || game.enableCustomDownloadButton ? 'download-for' : 'also-available-on'}`) }}</span
				>
				<div
					v-if="
						((!isWindows || game.enableCustomDownloadButton) && (game.pc || game.steam)) ||
							game.xbox ||
							game.psn ||
							((!isIOS || game.enableCustomDownloadButton) && game.ios) ||
							((!isAndroid || game.enableCustomDownloadButton) && game.android)
					"
					class="other-platforms"
				>
					<span
						v-if="(!isWindows || game.enableCustomDownloadButton) && (game.pc || game.steam)"
						:class="{ active: (isWindows && game.pc) || game.steam }"
						@click="pcClick()"
						>{{ $t('main.filters.pc') }}</span
					>
					<span v-if="game.xbox">{{ $t('main.filters.xbox') }}</span>
					<span v-if="game.psn">{{ $t('main.filters.psn') }}</span>
					<a
						v-if="(!isIOS || game.enableCustomDownloadButton) && game.ios"
						:href="game.ios"
						target="_blank"
						rel="external"
						@click="trackDownload('App Store')"
						>{{ $t('main.filters.ios') }}</a
					>
					<a
						v-if="(!isAndroid || game.enableCustomDownloadButton) && game.android"
						:href="game.android"
						target="_blank"
						rel="external"
						@click="trackDownload('Google Play Store')"
						>{{ $t('main.filters.android') }}</a
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import downloadGame from '../../plugins/launcherDownload';
import { getLocaleString } from '../../plugins/helpers';

export default {
	name: 'GameDetailsTopSection',
	components: {
		svgIcon,
	},
	props: {
		game: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			linksList: ['officialSite', 'forums'],
			linksList2: ['facebook', 'twitch', 'instagram', 'youtube', 'discord', 'twitter', 'tiktok'],
		};
	},
	computed: {
		...mapState(['isIOS', 'isAndroid', 'isWindows']),
		NXLogSessionId() {
			return this.$cookie.get('NxLogSession') ? this.$cookie.get('NxLogSession') : new Date().toISOString();
		},
		language() {
			return this.$i18n.locale;
		},
		region() {
			return environment.region;
		},
		memberShipNo() {
			return this.region === 'global' ? 1 : this.region === 'th' ? 3 : this.region === 'tw' ? 4 : this.region === 'sea' ? 5 : null;
		},
		isGameSupported() {
			return (
				(this.isWindows && (this.game.pc || this.game.steam)) ||
				(this.isIOS && this.game.ios) ||
				(this.isAndroid && this.game.android)
			);
		},
		isGameSupportedGaName() {
			return this.isGameSupported ? 'Supported' : 'Unsupported';
		},
	},
	mounted() {},
	methods: {
		download() {
			this.trackDownload('Download');
			downloadGame(this.game.productID, this.NXLogSessionId, this.memberShipNo, this.language, this.$route.query.partnerKey);
		},
		trackDownload(type) {
			dataLayer.push({
				event: 'Game Detail Download Area Click',
				gameDetailEngagementType: type,
				gameDetailSupported: this.isGameSupportedGaName,
				gameDetailName: this.game.name,
				gameDetailID: this.game.productID,
			});
		},
		openSteamLink(url) {
			this.trackDownload('Steam');
			this.openLink(url);
		},
		pcClick() {
			if (this.isWindows) {
				if (this.game.pc) {
					this.download();
					return;
				} else if (this.game.steam) {
					this.openSteamLink(this.game.steam);
				}
			} else {
				if (this.game.pc) {
					return;
				} else if (this.game.steam) {
					this.openSteamLink(this.game.steam);
				}
			}
		},
		openLink(url, link) {
			if (link) {
				dataLayer.push({
					event: 'Game Detail External Link Click',
					gameDetailExternalLink: this.$t(`main.links.${this.getLinkName(link)}`, 'en-US'),
					gameDetailName: this.game.name,
					gameDetailID: this.game.productID,
				});
			}
			window.open(typeof url === 'object' ? this.getLocaleString(url) : url, '_blank');
		},
		getLocaleString(data) {
			return getLocaleString(data, this.language);
		},
		getLinkName(link, isIcon) {
			let name = '';
			switch (link) {
				case 'officialSite':
					name = 'homepage';
					break;
				case 'forums':
					name = `${isIcon ? 'ext-' : ''}community`;
					break;
				default:
					name = `${isIcon ? 'ext-' : ''}${link}`;
			}
			return name;
		},
	},
};
</script>

<style lang="less" scoped>
.top-section {
	background-color: #1f2023;
	height: 100%;
	position: relative;
	user-select: none;
	width: 100%;
	.banner {
		background-position: top;
		background-size: cover;
		height: 460px;
		opacity: 0.2;
		pointer-events: none;
		position: absolute;
		top: 0;
		width: 100%;
		.shadow {
			&.desktop {
				display: none;
			}
			bottom: 0;
			height: 153px;
			position: absolute;
			width: 100%;
		}
	}
	.content {
		padding: 35px 20px 0;
		position: relative;
		width: 100%;
		.poster {
			background-position: center;
			background-size: cover;
			border-radius: 5px;
			box-shadow: 0 0 49px 0 rgba(0, 0, 0, 0.43);
			height: 253px;
			margin: auto;
			width: 187px;
		}
		.info {
			margin: 0 8px;
			.title {
				color: white;
				font-size: 39px;
				line-height: 1.25;
				margin-top: 35px;
				text-align: center;
			}
			.description {
				color: #a8a8a8;
				font-size: 16px;
				letter-spacing: -0.28px;
				line-height: 1.71;
				margin: 25px auto;
				max-width: 604px;
				text-align: center;
			}
			.links {
				margin: auto;
				margin-bottom: 10px;
				max-width: 604px;
				text-align: center;
				.link {
					align-items: center;
					color: #616163;
					cursor: pointer;
					display: inline-flex;
					font-size: 12.5px;
					margin: 0 7px 7px 0;
					transition: all 0.2s;
					text-transform: uppercase;
					&:hover {
						color: white;
						.link-icon {
							opacity: 1;
						}
					}
					&:active {
						color: rgba(255, 255, 255, 0.32);
						.link-icon {
							opacity: 0.3;
						}
					}
					.link-icon {
						height: 15px;
						margin-right: 7px;
						opacity: 0.4;
						transition: all 0.2s;
						width: 15px;
					}
				}
			}
			.links-top {
				.link:first-child {
					border: 1px solid rgba(255, 255, 255, 0.32);
					border-radius: 15px;
					padding: 5px;
					padding-left: 10px;
					padding-right: 10px;
					margin-right: 10px;
				}
				.link:nth-child(2) {
					vertical-align: 3px;
					.link-icon {
						display: none;
					}
				}
			}
		}
		.download {
			align-items: center;
			background-color: rgba(199, 199, 221, 0.05);
			border-radius: 5px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			margin: 40px auto 0;
			max-width: 600px;
			height: 150px;
			padding: 20px;
			button,
			a.steam,
			a.custom {
				align-items: center;
				background-color: #0077ff;
				border: none;
				border-radius: 5px;
				color: white;
				display: flex;
				font-size: 16px;
				font-weight: bold;
				height: 60px;
				justify-content: center;
				max-width: 600px;
				outline: none;
				padding: 0;
				text-transform: uppercase;
				transition: background-color 0.2s, background-color 0.2s, border-color 0.2s, color 0.2s;
				width: 100%;
				&:not(:active):hover {
					background-color: #4ca1ff;
				}
				&:active {
					background-color: #0052b3;
					color: #b3b3b4;
					.download-icon {
						opacity: 0.5;
					}
				}
				.download-icon {
					height: 15px;
					margin-right: 12px;
					width: 15px;
				}
			}
			a.ios,
			a.android {
				&.ios {
					img {
						height: 60px;
						width: 180px;
					}
				}
				&.android {
					img {
						height: 60px;
						width: 202px;
					}
				}
			}
			.also-available {
				color: rgba(255, 255, 255, 0.3);
				font-size: 12px;
				letter-spacing: -0.24px;
				&.spacing {
					margin-top: 20px;
				}
			}
			.other-platforms {
				color: rgba(255, 255, 255, 0.8);
				font-size: 14px;
				letter-spacing: -0.28px;
				margin-top: 10px;
				text-align: center;
				a,
				a:visited {
					color: rgba(255, 255, 255, 0.8);
					text-decoration: underline;
					&:hover {
						color: white;
					}
					&:active {
						color: #7e7e7f;
					}
				}
				:not(:first-child):before {
					content: '';
					margin-left: 2px;
				}
				:not(:last-child):after {
					content: ',';
				}
				.active {
					text-decoration: underline;
					&:hover {
						color: white;
						cursor: pointer;
					}
					&:active {
						color: #7e7e7f;
					}
				}
			}
		}
	}
}

@media (min-width: 1024px) {
	.top-section {
		background-color: #191a1c;
		.banner {
			height: 246px;
			opacity: 1;
			position: relative;
			.shadow {
				height: 163px;
				&.mobile {
					display: none;
				}
				&.desktop {
					display: block;
				}
			}
		}
		.content {
			display: flex;
			margin: auto;
			padding: 0;
			width: 770px;
			.poster {
				height: 166px;
				margin-top: -40px;
				min-width: 124px;
			}
			.info {
				margin: 0 0 0 25px;
				padding: 0 35px 0 0;
				.title {
					font-size: 27.5px;
					margin-top: 35px;
					text-align: left;
				}
				.description {
					font-size: 14px;
					margin: 15px 0 20px 0;
					min-width: 371px;
					text-align: left;
				}
				.links {
					text-align: left;
				}
			}
			.download {
				background-color: #1f2023;
				display: flex;
				height: 98px;
				justify-content: center;
				justify-self: flex-end;
				margin: 30px 0 0 0;
				min-width: 215px;
				padding: 0;
				button,
				a.steam,
				a.custom {
					font-size: 10.5px;
					height: 36px;
					margin: 0;
					width: 175px;
					.download-icon {
						height: 13px;
						margin-right: 9px;
						width: 10px;
					}
				}
				a.ios,
				a.android {
					margin: 0;
					&.ios {
						img {
							height: 36px;
							width: 108px;
						}
					}
					&.android {
						img {
							height: 36px;
							width: 121px;
						}
					}
				}
				.also-available {
					font-size: 10px;
					letter-spacing: -0.2px;
					&.spacing {
						margin-top: 7px;
					}
				}
				.other-platforms {
					font-size: 10.5px;
					letter-spacing: -0.21px;
					margin-top: 1px;
				}
			}
		}
	}
}

@media (min-width: 1280px) {
	.top-section {
		.banner {
			height: 325px;
			.shadow {
				height: 203px;
			}
		}
		.content {
			width: 960px;
			.poster {
				height: 208px;
				margin-top: -55px;
				min-width: 155px;
			}
			.info {
				padding: 0 95px 0 0;
				.description {
					min-width: 420px;
				}
			}
			.download {
				height: 123px;
				min-width: 265px;
			}
		}
	}
}

@media (min-width: 1440px) {
	.top-section {
		.banner {
			height: 344px;
			.shadow {
				height: 216px;
			}
		}
		.content {
			width: 1080px;
			.poster {
				height: 235px;
				margin-top: -45px;
				min-width: 174px;
			}
			.info {
				padding: 0 25px 0 0;
				.title {
					font-size: 39px;
				}
				.description {
					font-size: 16px;
					min-width: 525px;
				}
			}
			.download {
				height: 195px;
				margin: 40px 0 0 0;
				min-width: 331px;
				button,
				a.steam,
				a.custom {
					font-size: 16px;
					height: 60px;
					width: 270px;
					.download-icon {
						height: 15px;
						margin-right: 12px;
						width: 15px;
					}
				}
				a.ios,
				a.android {
					&.ios {
						img {
							height: 60px;
							width: 180px;
						}
					}
					&.android {
						img {
							height: 60px;
							width: 202px;
						}
					}
				}
				.also-available {
					font-size: 12px;
					letter-spacing: -0.24px;
					&.spacing {
						margin-top: 20px;
					}
				}
				.other-platforms {
					font-size: 14px;
					letter-spacing: -0.28px;
					margin-top: 7px;
				}
			}
		}
	}
}

@media (min-width: 1600px) {
	.top-section {
		.banner {
			height: 383px;
			.shadow {
				height: 289px;
			}
		}
		.content {
			width: 1200px;
			.poster {
				height: 280px;
				margin-top: -65px;
				min-width: 212px;
			}
			.info {
				.description {
					min-width: 604px;
				}
			}
		}
	}
}

@media (min-width: 1920px) {
	.top-section {
		.banner {
			height: 460px;
			.shadow {
				height: 289px;
			}
		}
		.content {
			width: 1440px;
			.poster {
				height: 304px;
				margin: -65px 0 0 0;
				min-width: 230px;
			}
			.info {
				padding: 0 180px 0 0;
			}
			.download {
				height: 190px;
				width: 400px;
			}
		}
	}
}
</style>
